var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeartDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.38133L8 13.3333L3 8.38133C2.6702 8.06041 2.41043 7.67467 2.23703 7.24842C2.06363 6.82217 1.98037 6.36463 1.99249 5.90462C2.00461 5.44461 2.11184 4.99209 2.30744 4.57555C2.50303 4.15902 2.78275 3.7875 3.12899 3.48438C3.47522 3.18127 3.88047 2.95312 4.3192 2.81432C4.75794 2.67551 5.22067 2.62905 5.67824 2.67786C6.13582 2.72668 6.57833 2.8697 6.97791 3.09793C7.3775 3.32617 7.7255 3.63466 8 4.004C8.27569 3.63734 8.62409 3.33154 9.0234 3.10573C9.42271 2.87992 9.86433 2.73896 10.3206 2.69168C10.7769 2.64439 11.2381 2.69179 11.6752 2.83092C12.1123 2.97005 12.516 3.19791 12.861 3.50024C13.206 3.80256 13.4849 4.17285 13.6803 4.58792C13.8756 5.003 13.9832 5.45392 13.9962 5.91247C14.0092 6.37102 13.9275 6.82732 13.7561 7.25283C13.5847 7.67833 13.3273 8.06388 13 8.38533",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartDesktop);
export default __webpack_public_path__ + "static/media/icon_heart_desktop.945b17fcad6d26a4d409647c47b995e3.svg";
export { ForwardRef as ReactComponent };